<template>
  <v-layout v-if="taxi" pl-2 pt-4 pr-2 pb-2 justify-center row>
    <v-flex xs12 sm10>
      <v-layout>
        <v-flex md6>
          <SimpleCard>
            <v-layout row wrap>
              <v-flex xs12>
                <h3>
                  Edit Taxi
                  <b>{{ taxi.registration_number }}</b>
                </h3>
              </v-flex>
              <v-flex xs12 md12>
                <TaxiForm
                    ref="taxiForm"
                    :disabled="false"
                    :taxi="taxi"
                    :errors="errors"
                    :rideTypes="rideTypes"
                    :councils="councils"
                    @validityChange="updateFormValidity($event)"
                />
              </v-flex>
              <v-flex xs12 md12 pb-4>
                <v-layout align-center justify-start row>
                  <v-checkbox
                      v-model="vehiclePhotoDeadlineModificationEnabled"
                      label="Enable Vehicle Photo Deadline Modification"
                      @change="updateVehiclePhotoDeadlineModificationEnabled"
                  />
                </v-layout>
              </v-flex>
              <v-flex xs12 md12 pb-4>
                <v-layout align-center justify-end row>
                  <v-btn v-if="taxi.taxi_verification_state !== 'verification_approved'" color="red" @click="reject"
                         class="text-none mr-2">Reject
                  </v-btn>
                  <v-btn v-if="taxi.taxi_verification_state !== 'verification_approved'" color="success" @click="accept"
                         class="text-none mr-2">Approve
                  </v-btn>
                  <v-btn color="success" @click="submit" class="text-none mr-2">Update</v-btn>
                </v-layout>
              </v-flex>
            </v-layout>
          </SimpleCard>
        </v-flex>
        <v-flex md6>
          <v-col
              cols="12"
              md="12"
              class="px-0 pl-1 py-0 mb-2"
          >
            <SimpleCard>
              <v-row>
                <v-col cols="12">
                  <v-card-title class="px-0 py-0">Taxi Documents</v-card-title>
                  <TaxiDocumentsBox ref="taxiDocs" :taxi="taxi"></TaxiDocumentsBox>
                </v-col>
              </v-row>
            </SimpleCard>
          </v-col>
          <v-col
              cols="12"
              md="12"
              class="px-0 pl-1 py-0"
          >
            <SimpleCard>
              <v-row>
                <v-col cols="12">
                  <v-card-title class="px-0 py-0">Associated Drivers</v-card-title>
                  <AssociatedDriverList
                      ref="associatedDriversList"
                      v-if="loading"
                      style="width: 100%"
                      :taxi="taxi"
                      @refresh="refreshAssociatedDrivers"
                  ></AssociatedDriverList>
                </v-col>
              </v-row>
            </SimpleCard>
          </v-col>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-snackbar v-model="snackbarShow" :color="snackbarColour" :timeout="4000">{{ snackbarMessage }}</v-snackbar>
  </v-layout>
</template>

<script>
import SimpleCard from "@/components/widget/SimpleCard.vue";
//TODO change directory of taxi form
import TaxiForm from "@/components/driver/TaxiForm.vue";
import AssociatedDriverList from "@/views/taxi/AssociatedDrivers.vue";

import qs from "qs";
import axios from "axios";
import DriverUploadedDocuments from "../../components/document/DriverUploadedDocuments.vue";
import TaxiDocumentsBox from "./TaxiDocumentsBox.vue";
import DriverDocumentsBox from "../driver/DriverDocumentsBox.vue";

axios.defaults.withCredentials = true;

export default {
  name: "edit_taxi",
  components: {
    DriverDocumentsBox, TaxiDocumentsBox, DriverUploadedDocuments,
    SimpleCard,
    TaxiForm,
    AssociatedDriverList
  },
  data: function () {
    return {
      rideTypes: null,
      taxi: null,
      councils: null,
      errors: {},
      formValid: false,
      snackbarShow: false,
      snackbarMessage: null,
      snackbarColour: null,
      vehiclePhotoDeadlineModificationEnabled: 0,
    };
  },
  mounted: async function () {
    this.getTaxi();
    this.getVehiclePhotoDeadlineModificationEnabled();
  },
  methods: {
    submit: function () {
      let self = this;
      let url = `${this.$store.state.apiUrl}/taxi/${this.taxi.id}/update`;

      if (this.formValid) {
        axios({
          url: url,
          method: "post",
          data: {
            user: this.user,
            driver: this.driver,
            driver_details: this.driver_details,
            taxi: this.taxi,
            pictureUrl: this.pictureUrl,
            currentDocuments: this.currentDriverDocuments
          },
          headers: {
            "Content-Type": "text/plain"
          }
        })
            .then(function (response) {
              if (response.data.errors) {
                self.errors = response.data.errors;
                self.snackbarMessage =
                    "Error updating taxi, please check the form";
                self.snackbarColour = "error";
                self.snackbarShow = true;
              } else if (response.data.error != "no_error") {
                self.snackbarMessage =
                    "Error updating taxi: " + response.data.error;
                self.snackbarColour = "error";
                self.snackbarShow = true;
                console.log(response.data.error);
              } else {
                const taxiID = response.data.taxi.id;
                alert("Taxi updated");
                self.$router.push("../../taxis");
              }
            })
            .catch(function (error) {
              console.log(error);
              self.snackbarMessage = error;
              self.snackbarColour = "error";
              self.snackbarShow = true;
            });
      } else {
        this.snackbarMessage = "Please complete the form before submitting";
        this.snackbarColour = "error";
        this.snackbarShow = true;
        this.$refs.taxiForm.validateForm();
      }
    },
    getTaxi: async function () {
      this.loading = true;
      try {
        var url = `${this.$store.state.apiUrl}/taxi/${this.$route.params.id}/get`;
        let response = await axios.get(url, {
          params: {}
        });

        console.log("GetTaxi: " + url);

        this.taxi = response.data.taxi;
        this.rideTypes = response.data.ride_types;
        this.councils = response.data.councils;
      } catch (error) {
        this.loading = false;
        console.log("Failed to get driver " + error);
      }
    },
    updateFormValidity: function (value) {
      this.formValid = value;
    },
    refresh: function () {
      this.$refs.taxiDocumentsList.refresh();
    },
    refreshAssociatedDrivers: function () {
      this.$refs.associatedDriversList.refresh();
    },
    async verdict(accept) {
      try {
        let response = await axios.post(
            `${this.$store.state.apiUrl}/taxi/taxiVerdict?id=${this.taxi.id}&accept=${accept}`,
            {},
            {
              headers: {
                "Content-Type": "application/x-www-form-urlencoded",
              },
            }
        );

        if (response.data.error === "no_error") {
          this.viewFileDialog = false;
          alert("Done");

          this.refresh();
        } else {
          if (response.data.message != null) {
            alert(response.data.message);
          } else {
            alert(response.data.error);
          }
        }
      } catch (error) {
        console.log(error);
        return "unknown_error";
      }
    },
    reject() {
      this.verdict(false);
    },
    accept() {
      this.verdict(true);
    },
    getVehiclePhotoDeadlineModificationEnabled: async function () {
      console.log("Calling getVehiclePhotoDeadlineModificationEnabled")
      let url = `${this.$store.state.apiUrl}/taxi_preLogin/get/${this.$route.params.id}`;

      try {
        let response = await axios.get(
            url,
            {},
            {
              headers: {
                "Content-Type": "application/x-www-form-urlencoded",
              },
            }
        );

        if (response.data.error === "no_error") {
          this.vehiclePhotoDeadlineModificationEnabled = response.data.vehiclePhotoDeadlineModificationEnabled;
        }

      } catch (error) {
        console.log(error);
        return "unknown_error";
      }

    },
    updateVehiclePhotoDeadlineModificationEnabled: async function () {
      let url = `${this.$store.state.apiUrl}/taxi_preLogin/editable/${this.taxi.id}?editable=`

      if(this.vehiclePhotoDeadlineModificationEnabled){
        url += "true"
      } else {
        url += "false"
      }

      try {
        let response = await axios.post(
            url,
            {},
            {
              headers: {
                "Content-Type": "application/x-www-form-urlencoded",
              },
            }
        );

      } catch (error) {
        console.log(error);
        return "unknown_error";
      }
    }
  },
};

</script>
